import styled from 'styled-components';
import Carousel from '@ertelecom/ui-react/components/carousel';
import * as S from '../styled';

export const List = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: min-content min-content;
    grid-gap: 5vw;

    @media(max-width: ${S.breakePoints.mobile}) {
        grid-template-columns: 1fr;
        grid-template-rows: min-content;
        grid-gap: 35px;
    }
`;

export const ListItem = styled(S.ListItem)`
    align-items: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        align-items: flex-start;
    }
`;

export const ImgWrap = styled(S.ImgWrap)`
    margin-bottom: 15px;
    height: 92px;

    @media(max-width: ${S.breakePoints.mobile}) {
        width: auto;
    }
`;

export const DataTitle = styled(S.DataTitle)`
    text-align: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        text-align: left;
    }
`;

export const DataText = styled(S.DataText)`
    margin-bottom: 20px;
    text-align: center;

    @media(max-width: ${S.breakePoints.mobile}) {
        text-align: left;
    }
`;

export const DataLink = styled(S.DataLink)`
    margin-top: auto;
    text-align: center;
`;
/* Slider */
export const TabsWrap = styled.div`
    width: 100%;
    background-color: #000;
    overflow: hidden;
`;

export const Slider = styled(Carousel)`
    &>div:last-child {
        &>div {
            background: #fff;
        }
    }
`;

export const SliderItem = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: 260px;

    @media(max-width: ${S.breakePoints.mobile}) {
        flex-direction: column;
        align-items: center;
        height: auto;
    }
`;

export const SliderImgWrap = styled(S.ImgWrap)`
    margin-right: 5vw;
    flex: 0 0 37%;
    width: 37%;
    transform: scale(1.2);

    @media(max-width: ${S.breakePoints.mobile}) {
        margin-bottom: 20px;
        flex: 0 0 70%;
        width: 70%;
        transform: none;
    }
`;

export const SliderDescription = styled(S.Description)`
    flex: 0 1 50%;
    justify-content: center;
    width: 50%;

    @media(max-width: ${S.breakePoints.mobile}) {
        flex: 0 1 100%;
        margin-bottom: 10px;
        width: 100%;
    }
`;

export const SliderTitle = styled(S.SectionTitle)`
    text-align: start;
    margin-bottom: 25px;
`;

export const SliderText = styled(S.DataText)`
    margin-bottom: 25px;
`;
/**/
export const TabContent = styled.div``;

export const CarouselTrackWrap = styled.div`
    @media(max-width: ${S.breakePoints.mobile}) {
        display: none;
    }
`;
